<nav class="navbar navbar-vertical navbar-expand-lg bg-body-tertiary">
  <div class="container-fluid">
    <a class="navbar-brand" href="/caandidato">
      <img src="https://informatemas.manpowergroupcolombia.co/wp-content/themes/stfinformationmp/library/images/manpowergroup-logo.png">      
    </a>

    <span class="navbar-text">
      Reclutamiento
    </span>

    <hr class="horizontal light mt-0 mb-2">

    <div class="collapse navbar-collapse" id="navbarText">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link active" aria-current="page" href="/candidato">Candidatos</a>
        </li>
      </ul>
    </div>

  </div>
</nav>